/* eslint-disable no-unsafe-optional-chaining */
import { Button } from 'primereact/button';
import { Paginator } from 'primereact/paginator';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { ROLES } from '../../../constants';
import { selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import './triad.scss';
import { TriadFirstTabV1 } from './TriadFirstTabV1';
import { TriadFirstTabV2 } from './TriadFirstTabV2';

interface TriadFirstTabProps {
    selectedEmployee: string | null;
    setTriadPageNumber: React.Dispatch<React.SetStateAction<number>>;
    setTriadPageNev: React.Dispatch<React.SetStateAction<number>>;
    handleStart: () => void;
    viewAnswers: (currTriad: any) => void;
    triadsList: any;
    inputMonth: number;
    inputYear: number;
    hirearchy: any;
    isConfigured: boolean;
}

export const TriadFirstTab = (props: TriadFirstTabProps) => {
    const [first, setFirst] = useState(0);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);


    useEffect(() => {
        if (props?.triadsList?.length - 1 < first)
            setFirst(props?.triadsList?.length - 1 > 0 ? props?.triadsList?.length - 1 : 0);
    }, [props?.triadsList, first]);

    useEffect(() => {
        props.setTriadPageNev(first);
    }, [first]);

    const onPageChange = (event: any) => {
        if (props.triadsList?.length < first || props.triadsList?.length === undefined) setFirst(0);
        else setFirst(event.first);
    };

    const handleStartForm = () => {
        props?.handleStart();
    };

    const isV1 = (triad: any): boolean =>
        triad ? triad.triad_version_id === 1 : !props?.isConfigured;

    const themeColor = (triad: any) => (isV1(triad) ? '#3299ff' : '#6366f1');

    const renderTab = (triad: any, created: boolean) => {
        return (
            <>
                <div style={{ height: "1px", background: "#e5e7eb", marginTop: 10 }} />
                <h3 className="margin-top-20">Coaching Assessment</h3>
                {isV1(triad) ? (
                    <TriadFirstTabV1
                        triad={triad}
                        created={created}
                        hirearchy={props?.hirearchy}
                        inputMonth={props?.inputMonth}
                        inputYear={props?.inputYear}
                        viewAnswers={props?.viewAnswers}
                    />
                ) : (
                    <TriadFirstTabV2 triad={triad} created={created} />
                )}
                {
                    <div className="button-container-triad">
                        <Button
                            label="Close"
                            onClick={() => props?.setTriadPageNumber(0)}
                            className="btn-secondary"
                            style={{ color: themeColor(triad) }}
                        />
                        <div className="">
                            {triad && (
                                <Button
                                    // style={{ backgroundColor: themeColor(triad), color: 'white', marginRight: '5px' }}
                                    onClick={() => props?.viewAnswers(props?.triadsList[first])}
                                    label="View Answers"
                                    className="btn-primary me-2"
                                />
                            )}
                            <Button
                                visible={
                                    (ROLES.Supervisor2AndManagers.includes(userManagerLevel) ||
                                        ROLES.DirectorOrAbove.includes(userManagerLevel)) &&
                                    props?.selectedEmployee !== null &&
                                    props?.selectedEmployee !== '' &&
                                    (
                                        (props?.inputMonth === new Date().getMonth() + 1 &&
                                            props?.inputYear === new Date().getFullYear()) ||
                                        (props?.inputMonth === undefined || props?.inputYear === undefined)
                                    )
                                }
                                onClick={handleStartForm}
                                label="Start Form"
                                className="btn-primary"
                                // style={{ backgroundColor: themeColor(triad), color: 'white' }}
                            />
                        </div>
                    </div>
                }
            </>
        );
    };
    return (
        <>
            {props?.triadsList?.length > 0 ? (
                <div className="p-10">{renderTab(props?.triadsList?.[first], true)}</div>
            ) : (
                <div className="p-10">{renderTab(props?.triadsList?.[first], false)}</div>
            )}

            {props?.triadsList?.length > 0 && (
                <div className="col-10">
                    <Paginator
                        first={first}
                        rows={1}
                        totalRecords={props?.triadsList?.length}
                        onPageChange={onPageChange}
                        template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    />
                </div>
            )}
        </>
    );
};
